module.exports = __webpack_public_path__ + "static/img/poster.4e67322.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/poster.png
// module id = kMOR
// module chunks = 0